module.exports = __webpack_public_path__ + "static/media/home-bg.ec56cf79.png";